import {AvatarStatus} from "components/ExpansionPanelTitleAvatar";
import {OfferMode} from "./OfferMode";

export const OfferPositionStatusType = {
    NO_OFFER: "NO_OFFER", //nieb
    INCOMPLETE: "INCOMPLETE", //dotkniety - nieskończony
    COMPLETED: "COMPLETED", //wypełniony - nieskończony
    PLACED: "PLACED", //złożony
    PLACED_INCOMPLETE: "PLACED_INCOMPLETE", //dotkniety - nieskończony
    PLACED_COMPLETED: "PLACED_COMPLETED", //wypełniony - nieskończony
    PLACED_OUT_OF_DATE: "PLACED_OUT_OF_DATE", //złożony - nieaktualny
    WITHDRAWN: "WITHDRAWN", //ziel
    WAITING_SIGNATURE: "WAITING_SIGNATURE", //ziel
    WAITING_WITHDRAW_SIGNATURE: "WAITING_WITHDRAW_SIGNATURE", //ziel
    WAITING_ADDITIONAL_OFFERS: "WAITING_ADDITIONAL_OFFERS" //ziel
}

export const OfferPositionStatusToAvatar = (status, mode) => {
    switch (status) {
        case OfferPositionStatusType.NO_OFFER:
            return AvatarStatus.Optional;
        case OfferPositionStatusType.INCOMPLETE:
            return AvatarStatus.Progress;
        case OfferPositionStatusType.COMPLETED:
            return AvatarStatus.Finished;
        case OfferPositionStatusType.PLACED:
            return AvatarStatus.Done;
        case OfferPositionStatusType.PLACED_INCOMPLETE:
            return AvatarStatus.Progress;
        case OfferPositionStatusType.PLACED_COMPLETED:
            return mode === OfferMode.PLACED ? AvatarStatus.Done : AvatarStatus.Finished;
        case OfferPositionStatusType.PLACED_OUT_OF_DATE:
            return mode === OfferMode.PLACED ? AvatarStatus.Finished : AvatarStatus.Required;
        case OfferPositionStatusType.WITHDRAWN:
            return AvatarStatus.Finished;
        case OfferPositionStatusType.WAITING_SIGNATURE:
            return AvatarStatus.Finished;
        case OfferPositionStatusType.WAITING_WITHDRAW_SIGNATURE:
            return AvatarStatus.Done;
        case OfferPositionStatusType.WAITING_ADDITIONAL_OFFERS:
            return AvatarStatus.Finished;
        default:
            return AvatarStatus.Wait;

    }
}

export const OfferPositionStatusesReadyToOffering = [OfferPositionStatusType.COMPLETED, OfferPositionStatusType.PLACED_COMPLETED, OfferPositionStatusType.WITHDRAWN]
export const OfferPositionStatusesReadyToOfferSign = [OfferPositionStatusType.WAITING_SIGNATURE]
export const OfferPositionStatusesReadyToWithdraw = [OfferPositionStatusType.PLACED, OfferPositionStatusType.PLACED_COMPLETED, OfferPositionStatusType.PLACED_INCOMPLETE]
export const OfferPositionStatusesReadyToWithdrawSign = [OfferPositionStatusType.WAITING_WITHDRAW_SIGNATURE]
export const OfferPositionStatusesReadyToDelete = [OfferPositionStatusType.INCOMPLETE, OfferPositionStatusType.COMPLETED]
